import * as d3 from "d3";
import * as React from "react";
import { PieChartData } from "./api";
import { Pie } from "./Pie";
import "./PieChart.css";

export interface PieChartProps {
    title: string;
    chart: PieChartData;
    className?: string;
}

export function PieChart(props: PieChartProps) {
    const valueScale = d3
        .scaleLinear()
        .domain([0, d3.sum(props.chart.series, s => s.value)])
        .range([0, 100]);

    return (
        <div className="PieChart">
            <div className="PieChart__title">{props.title}</div>
            <div className="PieChart__content">
                <div className="PieChartContent">
                    <div className="PieChartContent__chart">
                        <Pie className="PieChartContent__chart-svg" circleWidth={10} data={props.chart.series} />
                    </div>
                    <div className="PieChartContent__data PieChartContentData">
                        <div className="PieChartContentData__col-group">
                            <div className="PieChartContent__metric-set PieChartContentData__col">
                                {props.chart.series.map(metric => (
                                    <div
                                        key={`PieChart-metric-${metric.name}`}
                                        className="PieChartContent__metric PieChartContentData__item"
                                    >
                                        <span
                                            className="PieChartContent__metric-color"
                                            style={{ backgroundColor: metric.color }}
                                        >
                                            &nbsp;
                                        </span>{" "}
                                        {metric.name}
                                    </div>
                                ))}
                            </div>
                            <div className="PieChartContent__values PieChartContentData__col">
                                {props.chart.series.map(val => (
                                    <div key={val.name} className="PieChartContentData__item">{`${valueScale(
                                        val.value
                                    ).toFixed(2)}%`}</div>
                                ))}
                            </div>
                        </div>

                        {props.chart.additionalValueLabels &&
                            props.chart.additionalValueLabels.length &&
                            props.chart.additionalValueLabels.map((label, index) => (
                                <div
                                    className="PieChartContent__values additional PieChartContentData__col"
                                    key={`PieChart-AdditionalValueGroup-${index}`}
                                >
                                    <div className="PieChartContent__value-header">{label}</div>
                                    {props.chart.series.map(s => (
                                        <div
                                            key={`PieChartAdditionalValue-${index}-${s.name}`}
                                            className="PieChartContentData__item"
                                        >
                                            {(s.additionalValues || [])[index]}
                                        </div>
                                    ))}
                                </div>
                            ))}
                    </div>
                </div>
            </div>
            <div className="PieChart__footer">{props.chart.notes || ""}</div>
        </div>
    );
}
